import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-common-popup',
  templateUrl: './common-popup.component.html',
  styleUrls: ['./common-popup.component.scss'],
})
export class CommonPopupComponent {
  bookingOptions = [
    {
      img: '../../assets/images/individual-driver-ls.png',
      alt: 'Individual Driver',
      title: 'Book One Spot',
      route: 'truck-driver',
    },
    {
      img: '../../assets/images/driver-group-booking.png',
      alt: 'Group Booking',
      title: 'Book Multiple Spots',
      route: 'group-operator',
    },
  ];

  constructor(
    private readonly ref: DynamicDialogRef,
    private readonly router: Router
  ) {}

  close() {
    this.ref.close();
  }

  routeClick(data: string) {
    this.router.navigate([data]);
    this.close();
  }
}